
webpack.register(
    'components/date-formatter/date-formatter',
    function() {
        return import('components/date-formatter/date-formatter');
    },
    true
);